var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.menuAtivo,
            expression: "menuAtivo",
          },
        ],
        staticClass: "container-telas",
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.step == 1,
                expression: "step == 1",
              },
            ],
            staticStyle: { height: "100%", width: "100%" },
          },
          [
            _c("div", { staticClass: "header-tela" }, [
              _c("i", {
                staticClass: "fa-solid fa-angle-down me-3",
                style: { color: _vm.primaryColor },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Data")]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "padding-top": "30px",
                  "padding-left": "30px",
                  "padding-right": "30px",
                  height: "calc(100% - 50px)",
                  width: "100%",
                  overflow: "auto",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: { "font-size": "30px", "line-height": "20px" },
                  },
                  [_vm._v("Escolha")]
                ),
                _c("br"),
                _vm._v(" "),
                _c(
                  "strong",
                  {
                    staticStyle: { "font-size": "30px", "line-height": "28px" },
                    style: { color: _vm.primaryColor },
                  },
                  [_vm._v("a melhor data")]
                ),
                _vm._v(" "),
                _vm.useCalendar
                  ? _c("input-data-calendario", {
                      staticStyle: { "margin-top": "20px" },
                      attrs: {
                        "passeio-id": _vm.passeioId,
                        "is-mobile": true,
                        "initial-available-days": _vm.initialAvailableDays,
                        "calendar-size": _vm.calendarSize,
                      },
                      model: {
                        value: _vm.selectedDate,
                        callback: function ($$v) {
                          _vm.selectedDate = $$v
                        },
                        expression: "selectedDate",
                      },
                    })
                  : _c("input-data-list", {
                      staticStyle: { "margin-top": "20px" },
                      attrs: {
                        "passeio-id": _vm.passeioId,
                        "available-days": _vm.initialAvailableDays,
                        "return-days": _vm.returnDays,
                        "primary-color": _vm.primaryColor,
                      },
                      model: {
                        value: _vm.selectedDate,
                        callback: function ($$v) {
                          _vm.selectedDate = $$v
                        },
                        expression: "selectedDate",
                      },
                    }),
                _vm._v(" "),
                _c("div", {
                  staticStyle: {
                    height: "110px",
                    width: "100%",
                    "flex-shrink": "0",
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.step == 2,
                expression: "step == 2",
              },
            ],
            staticStyle: { height: "100%", width: "100%" },
          },
          [
            _c("div", { staticClass: "header-tela" }, [
              _c("i", {
                staticClass: "fa-solid fa-angle-down me-3",
                style: { color: _vm.primaryColor },
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.nomeItem))]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "padding-top": "30px",
                  "padding-left": "30px",
                  "padding-right": "30px",
                  height: "calc(100% - 50px)",
                  width: "100%",
                  overflow: "auto",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: { "font-size": "30px", "line-height": "20px" },
                  },
                  [_vm._v("Quantidade")]
                ),
                _c("br"),
                _vm._v(" "),
                _c(
                  "strong",
                  {
                    staticStyle: { "font-size": "30px", "line-height": "28px" },
                    style: { color: _vm.primaryColor },
                  },
                  [_vm._v("de " + _vm._s(_vm.nomeItem))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loadingAvailability,
                        expression: "loadingAvailability",
                      },
                    ],
                    staticStyle: {
                      "text-align": "center",
                      "margin-top": "20px",
                    },
                  },
                  [_c("i", { staticClass: "fa-regular fa-hourglass" })]
                ),
                _vm._v(" "),
                _c("input-tickets", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.loadingAvailability && _vm.selectedDate,
                      expression: "!loadingAvailability && selectedDate",
                    },
                  ],
                  staticStyle: { "margin-top": "20px" },
                  attrs: {
                    options: _vm.ageRanges,
                    "selected-date": _vm.selectedDate,
                    "primary-color": _vm.primaryColor,
                    min: _vm.quantidadeMinVenda,
                    max: _vm.quantidadeMaxVenda,
                    "is-mobile": true,
                    moeda: _vm.$props.moeda,
                    "nome-item": _vm.$props.nomeItem,
                  },
                  on: { "on-complience-state-change": _vm.complienceChange },
                  model: {
                    value: _vm.selectedAgeRanges,
                    callback: function ($$v) {
                      _vm.selectedAgeRanges = $$v
                    },
                    expression: "selectedAgeRanges",
                  },
                }),
                _vm._v(" "),
                _c("div", {
                  staticStyle: {
                    height: "110px",
                    width: "100%",
                    "flex-shrink": "0",
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.step == 3,
                expression: "step == 3",
              },
            ],
            staticStyle: { height: "100%", width: "100%" },
          },
          [
            _c("div", { staticClass: "header-tela" }, [
              _c("i", {
                staticClass: "fa-solid fa-angle-down me-3",
                style: { color: _vm.primaryColor },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Horário")]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "padding-top": "30px",
                  "padding-left": "30px",
                  "padding-right": "30px",
                  height: "calc(100% - 50px)",
                  width: "100%",
                  overflow: "auto",
                },
              },
              [
                _vm.horarios.length > 1
                  ? _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "30px",
                          "line-height": "20px",
                        },
                      },
                      [_vm._v("Escolha")]
                    )
                  : _vm._e(),
                _c("br"),
                _vm._v(" "),
                _c(
                  "strong",
                  {
                    staticStyle: { "font-size": "30px", "line-height": "28px" },
                    style: { color: _vm.primaryColor },
                  },
                  [_vm._v(_vm._s(_vm.tituloAbaHorario))]
                ),
                _vm._v(" "),
                _c("input-horario", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.loadingAvailability && _vm.selectedDate,
                      expression: "!loadingAvailability && selectedDate",
                    },
                  ],
                  staticStyle: { "margin-top": "20px" },
                  attrs: {
                    horarios: _vm.horarios,
                    "selected-quantities": _vm.selectedAgeRanges,
                    "primary-color": _vm.primaryColor,
                    "is-mobile": true,
                    "show-remaining-vacancies": _vm.showRemainingVacancies,
                    "passeio-tipo": _vm.passeioTipo,
                    "genero-titulo-atividade": _vm.generoTituloAtividade,
                    "titulo-atividade": _vm.tituloAtividade,
                  },
                  model: {
                    value: _vm.selectedAvailability,
                    callback: function ($$v) {
                      _vm.selectedAvailability = $$v
                    },
                    expression: "selectedAvailability",
                  },
                }),
                _vm._v(" "),
                _c("div", {
                  staticStyle: {
                    height: "110px",
                    width: "100%",
                    "flex-shrink": "0",
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.step == 4,
                expression: "step == 4",
              },
            ],
            staticStyle: { height: "100%", width: "100%" },
          },
          [
            _c("div", { staticClass: "header-tela" }, [
              _c("i", {
                staticClass: "fa-solid fa-angle-down me-3",
                style: { color: _vm.primaryColor },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Opcionais")]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "padding-top": "30px",
                  "padding-left": "30px",
                  "padding-right": "30px",
                  height: "calc(100% - 50px)",
                  width: "100%",
                  overflow: "auto",
                },
              },
              [
                _c(
                  "strong",
                  {
                    staticStyle: { "font-size": "28px", "line-height": "28px" },
                    style: { color: _vm.primaryColor },
                  },
                  [_vm._v("Melhore sua experiência")]
                ),
                _c("br"),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: { "font-size": "28px", "line-height": "26px" },
                  },
                  [_vm._v("com nossos opcionais")]
                ),
                _vm._v(" "),
                _c("input-opcionais", {
                  staticStyle: { "margin-top": "20px" },
                  attrs: {
                    "selected-date": _vm.selectedDate,
                    max: _vm.nPessoas,
                    "primary-color": _vm.primaryColor,
                    "mobile-mode": true,
                    "passeio-id": _vm.passeioId,
                    moeda: _vm.$props.moeda,
                  },
                  on: {
                    "optionals-availability-change": (av) =>
                      (_vm.hasOptionalsAvailable = av),
                  },
                  model: {
                    value: _vm.selectedOptionals,
                    callback: function ($$v) {
                      _vm.selectedOptionals = $$v
                    },
                    expression: "selectedOptionals",
                  },
                }),
                _vm._v(" "),
                _c("div", {
                  staticStyle: {
                    height: "110px",
                    width: "100%",
                    "flex-shrink": "0",
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "footer-container-alert-partial-payment" },
      [
        _vm.$props.hasPaymentPartial
          ? _c("alerta-pagamento-parcial", {
              attrs: {
                "preco-parcial-label": _vm.$props.precoParcial,
                "porcentagem-parcial": _vm.$props.porcentagemParcial,
                total: _vm.subtotal + _vm.totalOpcionais,
                moeda: _vm.$props.moeda,
                "is-mobile": true,
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "footer-container" },
      [
        _c("resumo-compra-mobile", {
          attrs: {
            "current-total": _vm.subtotal + _vm.totalOpcionais,
            "current-total-desconto": _vm.totalDesconto + _vm.totalOpcionais,
            preco: _vm.preco,
            "preco-original": _vm.precoOriginal,
            "preco-desconto": _vm.precoDesconto,
            "display-mode": !_vm.menuAtivo,
            "primary-color": _vm.primaryColor,
            "can-advance": _vm.canAdvance,
            submitting: _vm.isSubmitting,
            "menu-active": _vm.menuAtivo,
            moeda: _vm.$props.moeda,
            "preco-label": _vm.precoLabel,
            "discount-by-payment-method": _vm.$props.discountByPaymentMethod,
            "discount-payment-methods-label":
              _vm.$props.discountPaymentMethodsLabel,
          },
          on: {
            iniciar: function ($event) {
              _vm.menuAtivo = true
            },
            avancar: _vm.avancar,
            voltar: _vm.voltar,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }